import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Tooltip from 'Components/Molecules/Tooltip/Tooltip';
import Icon from 'Components/Atoms/Icon/Icon';
import Amount from 'Components/Molecules/Amount/Amount';
import { INVOICE_SUBTYPES, INVOICE_TYPES } from 'Utils/constants';

export default function InvoiceAmount(props) {
    const { invoice, className, showAccountingDelivered = true } = props;

    const { t } = useTranslation('invoices');

    const isReverse = [INVOICE_SUBTYPES.STANDARD_CORRECTIVE, INVOICE_SUBTYPES.SIMPLIFIED_CORRECTIVE].includes(
        invoice.subtype,
    );

    const amountWithType = invoice.type === 'purchase' ? invoice.amount * -1 : invoice.amount;
    const amount = isReverse ? amountWithType * -1 : amountWithType;

    const isIncome =
        (invoice.type === INVOICE_TYPES.SALE && !isReverse) || (invoice.type === INVOICE_TYPES.PURCHASE && isReverse);

    return (
        <div className="flex gap-2 justify-end items-center">
            {showAccountingDelivered && invoice.is_accounting_delivered && (
                <Tooltip label={t('accounting-delivered')}>
                    <span className="flex text-gray-400">
                        <Icon name="invoice-delivered" size={20} color="currentColor" />
                    </span>
                </Tooltip>
            )}
            <Amount
                amount={amount}
                currency={invoice.currency}
                isReverse={isReverse}
                isIncome={isIncome}
                reverseTooltipLabel={t('corrective-invoice')}
                className={className}
            />
        </div>
    );
}

InvoiceAmount.propTypes = {
    invoice: PropTypes.shape({
        amount: PropTypes.number,
        currency: PropTypes.string,
        type: PropTypes.string,
        subtype: PropTypes.string,
        is_accounting_delivered: PropTypes.bool,
    }).isRequired,
    className: PropTypes.string,
    showAccountingDelivered: PropTypes.bool,
};
